// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3u3iT","header":"MergedInvoice_header__53oWV"};